import Section_5 from './Section_5';

export default Section_5;